import React from "react";
import { useNavigate } from "react-router-dom";
import "./Category.css";

function Category() {
  const navigate = useNavigate();
  return (
    <div className="category">
      <ul>
        <li onClick={() => navigate("/product")}>Breakers</li>
        <li onClick={() => navigate("/cable")}>Cables</li>
        <li onClick={() => navigate("/contractor")}>Contactor</li>
        <li onClick={() => navigate("/timer")}>Timer</li>
      </ul>
    </div>
  );
}

export default Category;
